export default function CoreServices() {
  const services = [
    {
      title: 'Tax-Free Retirement',
      description: 'Build a tax-efficient retirement strategy with indexed universal life insurance that grows your wealth while minimizing tax burden.',
      icon: 'ri-money-dollar-circle-line',
      image: 'https://advancedbenefitdesigns.com/wp-content/uploads/2025/02/senior-couple-analyzing-their-savings-while-going-through-home-finances-1024x683.jpg'
    },
    {
      title: 'Long-Term Care Planning',
      description: 'Protect your assets and ensure quality care with comprehensive long-term care solutions tailored to your needs.',
      icon: 'ri-heart-pulse-line',
      image: 'https://advancedbenefitdesigns.com/wp-content/uploads/2025/02/interior-designer-working-with-young-couple-lovely-family-professional-designer-architector-discussing-conept-future-interior-working-with-colour-palette-room-drawings-modern-office-1024x683.jpg'
    },
    {
      title: 'Business Preservation',
      description: 'Safeguard your business legacy with succession planning, key person insurance, and buy-sell agreements.',
      icon: 'ri-building-line',
      image: 'https://advancedbenefitdesigns.com/wp-content/uploads/2025/02/senior-investor-buying-startup-handshaking-young-entrepreneur-group-meeting_1163-4888.webp'
    },
    {
      title: 'Medicare Insurance',
      description: 'Navigate Medicare options with confidence. We help you find the right coverage for your healthcare needs.',
      icon: 'ri-hospital-line',
      image: 'https://advancedbenefitdesigns.com/wp-content/uploads/2025/03/male-doctor-using-touchpad-explaining-medical-test-results-his-senior-patient-medical-ap-1024x683.webp'
    },
    {
      title: 'Estate Planning',
      description: 'Preserve your wealth for future generations with strategic estate planning and trust solutions.',
      icon: 'ri-file-shield-line',
      image: 'https://public.readdy.ai/ai/img_res/40be40d3d50438126cb6525da4119d8c.jpg'
    },
    {
      title: 'Mortgage Protection',
      description: 'Secure your family\'s home with mortgage protection insurance that pays off your mortgage in case of unexpected events.',
      icon: 'ri-home-heart-line',
      image: 'https://advancedbenefitdesigns.com/wp-content/uploads/2025/02/young-couple-holding-white-miniature-house-living-room-1024x683.jpg'
    },
    {
      title: 'Lifetime Income',
      description: 'Create a reliable income stream for retirement with fixed indexed annuities and lifetime income strategies.',
      icon: 'ri-line-chart-line',
      image: 'https://advancedbenefitdesigns.com/wp-content/uploads/2025/02/stem_students6-1024x675.jpg'
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Our <span className="text-teal-600">Core Services</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Comprehensive financial solutions designed to protect your wealth, secure your future, and support your business goals.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 border border-slate-100"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-teal-500 text-white shadow-lg">
                    <i className={`${service.icon} text-2xl`}></i>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-teal-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-4">
                  {service.description}
                </p>
                <button className="text-teal-600 font-semibold text-sm hover:text-teal-700 flex items-center gap-2 group/btn cursor-pointer whitespace-nowrap">
                  Learn More
                  <i className="ri-arrow-right-line group-hover/btn:translate-x-1 transition-transform"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
